import flow from 'lodash/flow';
import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import ListItems from './view';

export default flow(
	AnalyticsSubject('issue'),
	withFireUiAnalytics({
		onItemClick: (id: IssueId, level: number) => ({
			name: 'issue',
			level,
		}),
		onItemExpandChanged: (id: IssueId, isExpanded: boolean) => ({
			name: 'issue',
			type: isExpanded ? 'collapsed' : 'expanded',
		}),
	}),
)(ListItems);
